import { sanitizeHTML } from 'src/app/core/helpers/text-sanitizer';
import { GET_TABLE } from '../../../table.ui.store';
import Tooltip from 'src/app/project/features/tooltip/Tooltip';

export function createFooterTooltip(
  title: string,
  element: HTMLElement,
  trimTooltip: boolean = true,
): void {
  const table = GET_TABLE();

  const nameTooltip = new Tooltip({
    title: sanitizeHTML(title),
    mobileTooltip: false,
    childTooltip: false,
    trimTooltip,
    element: element,
    trimElement: element,
  });

  nameTooltip.createTooltip();
}
